<script setup>
import {
    ref,
    onMounted,
    watch
} from 'vue'
import { useRoute } from 'vue-router'
import Rules from '../components/Rules.vue'
import benefits from '../configs/premium.json'
import Launchers from '../configs/launcher.json'
import PremiumForm from '../components/premiumForm.vue'
import {
    DriverStore
} from '../pinia/Driver.js'
const Driver = DriverStore()
const route = useRoute()

var dialog = ref(false)
var model = ref()

// Ouvrir la boîte de dialogue si l'URL contient /premium
onMounted(() => {
    if (route.path === '/premium') {
        dialog.value = true
    }
})

// Surveiller les changements de route
watch(() => route.path, (newPath) => {
    if (newPath === '/premium') {
        dialog.value = true
    }
})

</script>

<template>
<div id="menu" @click="dialog = true">
    <v-icon :icon="'mdi-star'" v-if="!Driver.logged"></v-icon>
    <v-icon v-else :icon="Driver.user.premium == '1' ? 'mdi-star-check' : 'mdi-star'"></v-icon>

    <v-tooltip activator="parent" location="right">Premium</v-tooltip>
</div>

<v-dialog transition="dialog-bottom-transition" :width="500" v-model="dialog" scrollable>
    <v-card>
        <v-toolbar dark color="primary" class="premium-toolbar">
            <v-icon class="mr-2">mdi-star</v-icon>
            <div class="toolbar-content">
                <v-toolbar-title class="toolbar-main-title">Premium</v-toolbar-title>
                <div class="toolbar-subtitle">Support the server and unlock exclusive benefits</div>
            </div>
            <v-spacer></v-spacer>

            <template v-slot:extension>
                <v-tabs v-model="model" centered>
                    <v-tab value="1">
                        <v-icon class="mr-2" size="small">mdi-information</v-icon>
                        About
                    </v-tab>
                    <v-tab value="2">
                        <v-icon class="mr-2" size="small">mdi-gift</v-icon>
                        Benefits
                    </v-tab>
                    <v-tab value="3" v-if="Driver.logged">
                        <v-icon class="mr-2" size="small">mdi-cart</v-icon>
                        Buy
                    </v-tab>
                </v-tabs>
            </template>

        </v-toolbar>

        <v-card-text>
            <v-window v-model="model">
                <v-window-item value="1">
                    <div class="about-section">
                        <h2>What is Premium?</h2>
                        <p class="description">
                            NIGHTRIDERZ is a community-driven racing game server that brings players together from around the world. To maintain the best gaming experience possible, we rely on various infrastructure components that come with monthly costs.
                        </p>
                        
                        <div class="costs-grid">
                            <div class="cost-item">
                                <v-icon color="amber" size="x-large">mdi-server</v-icon>
                                <h3>Main Server</h3>
                                <p class="cost">€50/month</p>
                                <p class="detail">Our dedicated game server ensuring smooth gameplay for all players</p>
                            </div>
                            
                            <div class="cost-item">
                                <v-icon color="amber" size="x-large">mdi-email</v-icon>
                                <h3>Email Service</h3>
                                <p class="cost">€16/month</p>
                                <p class="detail">Keeps you informed about events and account security</p>
                            </div>
                            
                            <div class="cost-item">
                                <v-icon color="amber" size="x-large">mdi-test-tube</v-icon>
                                <h3>Test Server</h3>
                                <p class="cost">€15/month</p>
                                <p class="detail">Where we test new features before they go live</p>
                            </div>
                            
                            <div class="cost-item">
                                <v-icon color="amber" size="x-large">mdi-cloud</v-icon>
                                <h3>CDN</h3>
                                <p class="cost">€1/month</p>
                                <p class="detail">Fast content delivery worldwide</p>
                            </div>
                        </div>

                        <div class="costs-summary">
                            <div class="total-section">
                                <v-icon color="amber" size="x-large">mdi-chart-bar</v-icon>
                                <h3>Monthly Server Costs</h3>
                                <p class="total"><b>€82</b></p>
                                <p class="detail">Total running costs to keep the servers online</p>
                            </div>

                            <div class="premium-section">
                                <v-icon color="amber" size="x-large">mdi-star</v-icon>
                                <h3>Premium Support</h3>
                                <p class="premium-price"><b>€5.99</b></p>
                                <p class="detail">One-time payment, lifetime access</p>
                            </div>
                        </div>

                        <p class="support-note">
                            By becoming a Premium member, you're directly supporting the server's infrastructure while getting exclusive benefits. Your one-time contribution helps us maintain and improve the gaming experience for everyone.
                        </p>
                    </div>
                </v-window-item>
                <v-window-item value="2">
                    <div class="benefits-section">
                        <div class="benefits-grid">
                            <div v-for="benefit in benefits" :key="benefit.title" class="benefit-card">
                                <div class="benefit-icon">
                                    <v-icon size="x-large" :icon="'mdi-' + benefit.icone"></v-icon>
                                </div>
                                <h3>{{ benefit.title }}</h3>
                                <p v-html="benefit.text"></p>
                            </div>
                        </div>
                    </div>
                </v-window-item>
                <v-window-item value="3" v-if="Driver.logged">
                    <PremiumForm />
                </v-window-item>
            </v-window>
        </v-card-text>

    </v-card>
</v-dialog>
</template>

<style scoped>
.paypal {
    margin: 10px;
}

.v-list-item {
    padding: 3px;
}

.v-list-item::v-deep(.v-list-item-title) {
    margin-bottom: 2px !important;
}

.v-toolbar {
    background: linear-gradient(90deg, rgb(255 165 0) 0%, rgb(255 235 0) 100%) !important;
}

p {
    text-align: center;
}

.about-section {
    padding: 1.5rem;
    max-height: 60vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 215, 0, 0.5) rgba(255, 255, 255, 0.1);
}

.about-section::-webkit-scrollbar {
    width: 8px;
}

.about-section::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
}

.about-section::-webkit-scrollbar-thumb {
    background-color: rgba(255, 215, 0, 0.5);
    border-radius: 4px;
}

.about-section::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 215, 0, 0.7);
}

.about-section h2 {
    color: #ffd700;
    font-size: 1.8rem;
    margin-bottom: 1rem;
    text-align: center;
}

.description {
    color: #ccc;
    text-align: center;
    margin-bottom: 2rem;
    font-size: 1rem;
    line-height: 1.5;
}

.costs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    margin: 2rem 0;
}

.cost-item {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 1.5rem;
    text-align: center;
    transition: transform 0.2s;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.cost-item:hover {
    transform: translateY(-5px);
}

.cost-item h3 {
    color: #ffd700;
    margin: 1rem 0;
    font-size: 1.2rem;
}

.cost-item .cost {
    font-size: 1.3rem;
    font-weight: bold;
    color: #fff;
    margin: 0.5rem 0;
}

.cost-item .detail {
    color: #ccc;
    font-size: 0.9rem;
    line-height: 1.4;
}

.costs-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    margin: 2rem 0;
}

.total-section, .premium-section {
    background: rgba(255, 215, 0, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    text-align: center;
    transition: transform 0.2s;
    border: 1px solid rgba(255, 215, 0, 0.2);
}

.total-section:hover, .premium-section:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.total-section h3, .premium-section h3 {
    color: #ffd700;
    margin: 1rem 0;
    font-size: 1.2rem;
}

.total {
    font-size: 2rem;
    color: #fff;
    margin: 1rem 0;
    font-weight: bold;
}

.premium-price {
    color: #ffd700;
    font-size: 2rem;
    margin: 1rem 0;
    font-weight: bold;
}

.detail {
    color: #ccc;
    font-size: 0.9rem;
    line-height: 1.4;
    margin-top: 0.5rem;
}

.support-note {
    color: #ccc;
    text-align: center;
    margin-top: 1.5rem;
    font-style: italic;
    line-height: 1.5;
}

.downloadbtn {
    display: flex;
    justify-content: center;
    margin: 10px 0;
}

button {
    margin: initial !important;
}

#menu {
    font-weight: bold;
    color: white;
    text-decoration: none;
    border-radius: 6px;
    margin-bottom: 10px;
    height: 40px;
    width: 40px;
    background: transparent;
    transition: all 0.15s ease-in-out;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    cursor: pointer;
    background: linear-gradient(90deg, rgb(255 165 0) 0%, rgb(255 235 0) 100%) !important;
}

button:hover {
  background: rgb(255 179 37 / 55%)!important;
}

#menu i {
    margin: 0 7px;
}

.router-link-active {
    font-weight: bold;
    border-left: 2px solid white;
    background: var(--tertiary-color) !important;
    color: white;
    vertical-align: middle;
}

#menu:hover {
    font-weight: bold;
    background: var(--quaternary-color);
    color: white;
    vertical-align: middle;
}

/* Styles pour la section Benefits */
.benefits-section {
    max-height: 60vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 215, 0, 0.5) rgba(255, 255, 255, 0.1);
    padding: 1rem;
}

.benefits-section::-webkit-scrollbar {
    width: 8px;
}

.benefits-section::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
}

.benefits-section::-webkit-scrollbar-thumb {
    background-color: rgba(255, 215, 0, 0.5);
    border-radius: 4px;
}

.benefits-section::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 215, 0, 0.7);
}

.benefits-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
}

.benefit-card {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 1.5rem;
    transition: transform 0.2s, box-shadow 0.2s;
    border: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
}

.benefit-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.benefit-icon {
    margin-bottom: 1rem;
}

.benefit-card h3 {
    color: #ffd700;
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
}

.benefit-card p {
    color: #ccc;
    font-size: 0.9rem;
    line-height: 1.4;
    text-align: center;
}

/* Toolbar Styles */
.premium-toolbar {
    padding: 8px 16px !important;
}

.toolbar-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
}

.toolbar-main-title {
    font-size: 1.25rem !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
}

.toolbar-subtitle {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1;
}

</style>
